import { req } from 'react-reqq-lite';

import { withAclReq } from 'modules/partial/hooks';
import { formatedSelectOption, removeEmpty } from 'modules/common/utils';

const prefix = 'BRANCH/SERVICES/SERVICES';

export const GET_CART = `${prefix}/GET_CART`;
export const GET_DISCOUNTS = `${prefix}/GET_DISCOUNTS`;
export const GET_DISCOUNT_TYPES = `${prefix}/GET_DISCOUNT_TYPES`;
export const GET_DISCOUNT_TYPES_V2 = `${prefix}/GET_DISCOUNT_TYPES_V2`;
export const GET_SELECTED_DISCOUNT = `${prefix}/GET_SELECTED_DISCOUNTx`;
export const POST_DISCOUNT = `${prefix}/POST_DISCOUNT`;
export const GET_SETTINGS = `${prefix}/GET_SETTINGS`;
export const PATCH_DISCOUNT = `${prefix}/PATCH_DISCOUNT`;
export const REMOVE_DISCOUNT = `${prefix}/REMOVE_DISCOUNT`;
export const POST_QUICK_CHECKOUT = `${prefix}/POST_QUICK_CHECKOUT`;
export const PUT_QUICK_CHECKOUT = `${prefix}/PUT_QUICK_CHECKOUT`;
export const BRANCH_OPTIONS = `${prefix}/BRANCH_OPTIONS`;
export const TABLE_OPTIONS = `${prefix}/TABLE_OPTIONS`;
export const CHECKOUT_ORDER = `${prefix}/CHECKOUT_ORDER`;
export const GET_SELECTED_CART = `${prefix}/GET_SELECTED_CART`;
export const ADD_PRODUCT = `${prefix}/ADD_PRODUCT`;
export const GET_CHARGES = `${prefix}/GET_CHARGES`;

export const getTableOpts =
  ({ merchant_uuid, params = {} }) =>
  async (input = '', cb) => {
    const args = {
      ...params,
      keyword: input,
      per_page: 25,
      sort_by: 'asc',
    };

    if (!params?.branch_uuid) return;

    await req.get(
      withAclReq(
        () => ({
          ADMIN: {
            url: `/v1/vendors/${merchant_uuid}/pos`,
          },
          MERCHANT: {
            url: '/v1/me/pos',
          },
        }),
        {
          key: TABLE_OPTIONS,
          params: removeEmpty(args),
          onSuccess: (res) => {
            const { data } = res?.response;

            const x = formatedSelectOption(
              data,
              'attributes.key',
              'attributes.name',
              {
                isLabelUpperCase: false,
              }
            );

            cb(x);
          },
        }
      )
    );
  };
